
// You can write more code here

/* START OF COMPILED CODE */

import EditorMarker from "../../EditorMarker";
import SimpleBreakableBlocker from "../../../components/platformer/SimpleBreakableBlocker";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class SmashableMarkerRocks extends EditorMarker {

  constructor(scene: Phaser.Scene, x?: number, y?: number, texture?: string, frame?: number | string) {
    super(scene, x ?? 76, y ?? 187, texture || 'game-all', frame ?? "smashable-rocks.png");

    // this (components)
    new SimpleBreakableBlocker(this);

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
